// extracted by mini-css-extract-plugin
export default {"container":"pp-z","heading":"qp-z","text":"rp-z","info":"sp-z","link":"tp-z","fullMaxWidth":"up-z"};